import { useEffect, useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

interface Props {
  placeholder?: string;
  initialValue?: string;
  onSearch: (query: string) => void;
  debounceMs?: number;
}

const DEFAULT_DEBOUNCE_MS = 300;

export function DebouncedSearchBar(props: Props): React.ReactElement {
  const {
    placeholder = "Search",
    initialValue = "",
    onSearch,
    debounceMs = DEFAULT_DEBOUNCE_MS,
  } = props;
  const [value, setValue] = useState<string>(initialValue);

  useEffect(() => {
    const id = window.setTimeout(() => {
      onSearch(value);
    }, debounceMs);
    return () => {
      window.clearTimeout(id);
    };
  }, [value, debounceMs, onSearch]);

  const handleClear = (): void => {
    setValue("");
  };

  return (
    <TextField
      fullWidth
      value={value}
      placeholder={placeholder}
      onChange={(event) => {
        setValue(event.target.value);
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment:
            value.length > 0 ? (
              <InputAdornment position="end">
                <IconButton size="small" aria-label="Clear search" onClick={handleClear}>
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
        },
      }}
    />
  );
}
